import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCreateProductFamilyMutation, useGetAllProductFamiliesQuery } from '../features/products/productSlice';
import {ProductFamilyCard, OthersFamilyCard} from '../components/ProductFamilyCard';
import Loading from '../components/Loading';
import { ProductAddNewCard } from '../components/ProductCard';

const ProductFamilyBrowser = () => {
    const {data: families, error, isLoading } = useGetAllProductFamiliesQuery()
    const [createProductFamily] = useCreateProductFamilyMutation();

    if (isLoading || !families) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const makeLinkToFamily = (family) => {
      return `/products/${family}`
    }

    const addProductFamily = (name) => {
      let new_family = {
        name: name
      };
      createProductFamily({data: new_family});
    }

    return (
      <>
        <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
          {families.objects.map((family, i) => <Grid item key={family.id} component={Link} to={makeLinkToFamily(family.id)}>{ProductFamilyCard(family)}</Grid>)}
          <Grid item key='_others' component={Link} to={makeLinkToFamily('_others')}><OthersFamilyCard /></Grid>
          <Grid item key="add_new"><ProductAddNewCard onAddProduct={addProductFamily}/></Grid>
        </Grid>
      </>
    );
}

export default ProductFamilyBrowser;
